import * as Yup from 'yup';
import { DictionaryIrzActivity } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryIrzActivity>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
